import $ from 'jquery';
import { compare, stringCompare, floatCompare } from '../../common/compare';

export default class TyreApiClient {
  constructor(quoteService) {
    this.quoteService = quoteService;
  }

  fetchTyreSpecs(position, selections, repopulateAll = false, callback) {
    const selection = selections.specification(position);

    let url = '/tyre_specifications';
    const params = [selection.width, selection.profile, selection.rim, selection.speed].filter(Boolean).join('/');
    if (params) {
      url = url + '/' + params + '?render=funnel';
    }

    $.ajax({
      method: 'GET',
      url: url,
      success: function (data) {
        if (callback) callback(data);
      },
    });
  }

  fetchTyres(selections, callback) {
    const positions = selections.symmetric() ? ['front'] : selections.positions(),
      tyres = [],
      meta = {},
      symmetric = selections.symmetric();

    positions.forEach((position) => {
      const positionKey = selections.symmetric() ? 'both' : position;
      let specification = selections.specification(position);
      let url = '/tyres/' + specification.toParam() + '?quantity=' + selections.totalQuantity();
      const selected_tyre = selections.tyre(positionKey);
      if (selected_tyre) url = url + '&supplier_code=' + selected_tyre.supplier_code;
      $.ajax({
        method: 'GET',
        url: url,
        success: function (data) {
          meta[positionKey] = { count: data.length };
          data.forEach((tyre) => {
            tyre.position = positionKey;
            tyre.quantity = symmetric ? selections.totalQuantity() : selections.quantity(position);
            tyres.push(tyre);
          });
          positions.splice(positions.indexOf(position), 1);
          if (positions.length === 0) {
            tyres.sort(compare(stringCompare('position'), floatCompare('fitted_price')));

            meta.totalCount = Object.keys(meta).reduce((total, position) => {
              return total + meta[position].count;
            }, 0);
            callback(tyres, meta);
          }
        },
      });
    });
  }

  deleteTyres(position) {
    let url = '/booking/tyres';
    if (position !== 'both') {
      url = url + '/' + position;
    }
    this.quoteService.executeQuote(function (success, error) {
      $.ajax({
        method: 'DELETE',
        url: url,
        success: success,
        error: error,
      });
    });
  }

  fetchTyresQuote(tyres_data, position) {
    let url = '/booking/tyres';
    if (position !== 'both') {
      url = url + '/' + position;
    }

    this.quoteService.executeQuote(function (success, error) {
      $.ajax({
        method: 'POST',
        url: url,
        data: tyres_data,
        success: success,
        error: error,
      });
    });
  }

  fetchTyreSummary(callback) {
    $.ajax({
      method: 'GET',
      url: '/booking/tyres',
      success: function (data) {
        ['front', 'rear'].forEach((position) => {
          if (data[position]) data[position].specification.speed = data[position].specification.speed_rating;
        });
        callback(data);
      },
    });
  }
}
